export default __webpack_public_path__ + "static/media/NOT_ELIGIBLE.560ce026.svg";